<script setup lang="ts">
const props = defineProps<{
  errors: Record<string, string[]>,
}>();

const errorsArray = computed(() => {
  const valErrors = props.errors;
  const arrayErrors: string[] = [];

  for (const [, keyErrors] of Object.entries(valErrors)) {
    keyErrors.forEach((value) => {
      arrayErrors.push(value);
    });
  }
  return arrayErrors;
});
</script>

<template>
  <div v-for="error in errorsArray" :key="error">
    {{ error }}
  </div>
</template>
